import { api } from "../../api";
import { HOME_ROWS_ENDPOINTS } from "../../../constants/endpoints";

export const homeRowsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // Recupera tutte le righe della homepage ordinate
        getHomeRowsClient: builder.query({
            query: () => ({
                url: HOME_ROWS_ENDPOINTS.GET_ALL_CLIENT,
                method: "POST",
            }),
            providesTags: ["HomeRow"],
        }),

        getHomeRows: builder.query({
            query: () => ({
                url: HOME_ROWS_ENDPOINTS.GET_ALL,
                method: "POST",
            }),
            providesTags: ["HomeRow"],
        }),

        // Aggiorna una riga (ma NON il titolo: quello viene da Category/PlaylistCategory o è fisso)
        updateHomeRow: builder.mutation({
            query: (body) => {
                // elimino eventuale title dal payload per sicurezza
                const { title, ...safeBody } = body;
                return {
                    url: HOME_ROWS_ENDPOINTS.UPDATE,
                    method: "POST",
                    body: safeBody,
                };
            },
            invalidatesTags: ["HomeRow"],
        }),

        // Salva l’ordine delle righe (array di ID)
        saveHomeRowsOrder: builder.mutation({
            query: (body) => ({
                url: HOME_ROWS_ENDPOINTS.SAVE_ORDER,
                method: "POST",
                body,
            }),
            invalidatesTags: ["HomeRow"],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetHomeRowsClientQuery,
    useGetHomeRowsQuery,
    useUpdateHomeRowMutation,
    useSaveHomeRowsOrderMutation,
} = homeRowsApi;
